<template>
  <div class='privacywarp'>
      <div class="privcenter">
          <p v-html="htmls"></p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'privacys',
  data(){
    return {
        htmls:`
<div style="line-height:1.5;padding:30px 15px;">
    <h4 style="font-size: 16px;margin-bottom: 20px;text-align:center;">园林工程技术专业教学资源库隐私政策</h4>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">河南优浩教育科技有限公司（简称“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品和服务时，我们可能会收集和使用您的相关信息。我们希望通过本《园林工程技术专业教学资源库隐私政策》（以下简称"本政策"）向您说明在您接受我们的产品服务时，我们如何收集、使用、储存、共享和转让这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">请在使用我们的服务前，仔细阅读并了解本政策。如果您不同意本政策的内容，将导致我们无法为您提供完整的服务，同时也请您立即停止使用我们的产品和服务。您使用或继续使用我们提供的产品和/或服务，则表示您同意我们按照本政策收集、使用、存储和分享、披露、保护您的个人信息。如您对本政策内容有任何疑问、意见或建议，请通过文末的方式与我们联系。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">当您点击确认同意本政策，即表示您已充分阅读、理解且接受本政策的全部内容，并与我们达成一致，本政策对您及我们均具有法律约束力。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;" style="font-size:12px;margin-bottom: 10px;color: #333333;">一、本隐私协议适用范围、相关词语涵义</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（一）本政策适用范围</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">本政策适用于您使用园林工程技术专业教学资源库平台的所有产品与/或服务时使用。当您使用我们的任何产品与/或服务时，如该产品与/或服务单独设置了隐私条款/隐私协议的，单独的隐私条款/隐私协议优先适用；单独的隐私条款/隐私协议未提及的内容，适用本政策。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（二）相关词语涵义</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括自然人的基本资料（包括姓名、出生日期、性别、电话号码）、个人身份信息（包括身份证件号码、身份证正反照）、个人生物识别信息（包括面部特征）、网络身份标识信息（包括系统账号、IP地址）、个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备标识符）我们实际具体收集的个人信息种类以下文描述为准。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策中涉及的个人敏感信息包括您的个人身份信息（包括身份证件号码）、个人生物识别信息、网络身份标识信息。我们实际具体收集的个人敏感信息种类以下文描述为准。您同意您的个人敏感信息按本政策所述的目的和方式来处理。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">设备：是指可用于访问我们的产品和/或服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">唯一设备标识符（专属ID或UUID）：是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（例如手机的IMEI号）。</p>
    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">唯一设备标识符有多种用途，其中可在不能使用Cookie（例如在移动应用程序中）时用以提供广告。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">IP地址：每台上网的设备都会指定一个编号，称为互联网协议(IP)地址。这些编号通常都是根据地理区域指定的。IP地址通常可用于识别设备连接至互联网时所在的位置。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">SSL：SSL（SecureSocketLayer）又称为安全套接层，是在传输通信协议（TCP/IP）上实现的一种安全协议。SSL支持各种类型的网络，同时提供三种基本的安全服务，均通过使用公开密钥和对称密钥技术以达到信息保密的效果。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">账号：当您注册账号并向我们提供一些个人信息，您就可以更好的使用我们的服务。当您使用我们的服务时，系统会利用这些账号信息对您进行身份验证，以防止未经授权的人员访问您的账号。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">服务器日志：通常情况下，我们的服务器会自动记录您在访问网站时所发出的网页请求。这些“服务器日志”通常包括您的网络请求、互联网协议地址、浏览器类型、浏览器语言、请求的日期和时间及可以唯一识别您的浏览器的一个或多个Cookie。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">二、信息收集范围</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">园林工程技术专业教学资源库平台仅会出于本隐私政策所述的以下目的，收集和使用您的个人信息：</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、为完成园林工程技术专业教学资源库平台账户的注册、管理、实名认证等必要活动，您需要提交真实、合法、有效的信息，包括但不限于您的姓名、身份证号码、身份证正反照、手机号、人脸生物信息、头像等。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、您使用本服务时，可能收集已经经过您授权获取或主动填写的如下信息：</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（1）日志信息，指您使用我们的服务时，系统可能通过自动采集的技术信息，包括：</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">• 设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址、MAC地址和移动设备所用的版本和设备识别码（IMEI）。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">• 您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。</p>


    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（2）如果您需要使用部分可选的功能或服务如人脸认证功能等，您还应该提供使用该功能或服务所必须的信息，如人脸生物信息等。</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（3）我们会利用收集的信息（例如您的手机号码）直接与您沟通。</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（4）当我们要将信息用于本隐私政策未载明的其他用途，将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">三、我们如何收集个人信息</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">您在使用我们的产品与/或服务时，我们需要/可能需要收集和使用您的一些个人信息，我们需要特别提醒您的是：由于我们的产品和服务较多，为您提供的内容也不同，因此核心业务功能（包括其收集的您的个人信息类型）也会因产品/服务的内容不同而有所区别，具体以产品/服务实际提供为准。除此之外，您理解并同意，我们希望提供给您的产品和服务是完善的，所以我们会不断改进我们的产品和服务，包括技术，这意味着随着产品和服务的迭代、拓展、升级等，我们可能会经常推出新的业务功能或重新划分业务功能，并可能需要收集新的个人信息或变更个人信息使用目的或方式。如果某一需要收集您的个人信息的功能或产品/服务未能在本《园林工程技术专业教学资源库平台政策》中予以说明的，我们会通过更新本政策、启动或浏览界面提示、弹窗、网站公告等一种或多种方式另行向您说明该信息收集的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您同意后收集。在此过程中，如果您对相关事宜有任何疑惑的，可以通过文末提供的方式联系我们，我们会尽快为您作出解答。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（一）服务内容展示/浏览/播放/下载功能</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">我们的产品与/或服务为您提供视频、题库等服务内容的展示、浏览、播放、练习、模考，在此过程中，我们会根据您使用我们产品与/或服务的具体操作收集您的一些信息，包括如下个人信息：</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、设备信息：包括设备MAC地址、唯一设备识别码、登录IP地址、设备型号、设备名称、设备标识。为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限并根据您的授权获取相关信息。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、日志信息：当您使用我们的产品与/或服务时，我们会自动收集您的有关操作日志、服务日志保存，包括您的浏览记录、播放记录、播放时长、访问日期和时间、弹窗管控、人脸识别。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">我们收集这些信息是为了向您提供我们最核心的服务内容展示/播放，如您拒绝提供上述信息/或权限将可能导致您无法使用我们的产品与服务。请您知悉，单独的设备信息、日志信息等无法识别您的身份信息。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（二）身份验证功能</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">当您使用我们的产品与/或服务中的身份认证功能或服务时，为满足相关监管要求、确保用户身份真实性和服务安全或提供服务之需要，我们将需要收集您的真实身份信息（可能包括姓名、身份证相关信息、面部特征信息（静态或动态）、手机号码）（个人敏感信息）以完成实名认证，相关业务场景可能包括：实名认证、课程学习过程中人脸认证，为实现实名认证的目的，您同意我们可以自行或委托第三方向有关机构（如政府机构等）提供、查询、核对您的前述身份信息。在您实名认证成功后，如无正当事由，实名信息将无法修改，如确需修改，请您与我们联系解决。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（三）意见反馈功能</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">可以通过我的-意见反馈向我们反馈问题，我们可能还会需要收集您的如下个人个人信息：联系方式（手机号码、QQ、微信）、您与我们的沟通信息（包括文字/图片形式）。我们会根据问题原因并努力解决问题。您在反馈意见中所提供的联系方式，只会用于与您沟通与反馈，除征得用户明确同意和法律明确规定外，公司不会向任何第三方提供您提供的联系信息。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（四）为您提供个性化服务</h5>


    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、基于图片上传的功能：您可以上传您的照片来实现头像的更换。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">上述附加功能可能需要您在您的设备中向我们开启您相册（图片库），以实现这些功能所涉及的信息的收集和使用。我们将在您具体使用到上述所列功能时逐一以弹窗的形式提前向您提示，您可以根据您的需要进行选择。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（五）产品安全保障功能</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">我们需要收集您的一些信息来保障您使用我们的产品与/或服务时的账号与系统安全，并协助提升我们的产品与/服务的安全性和可靠性，以防产生任何危害用户、平台、社会的行为，包括您的如下个人信息：账号登录地、个人常用设备信息（例如：硬件型号、设备MAC地址、IMEI、IMSI）、登录IP地址，以及个人敏感信息：学员实名认证信息。我们会根据上述信息来综合判断您账号、进行身份验证、客户服务，一旦我们检测出存在或疑似存在账号安全风险时，我们会使用相关信息进行安全验证与风险排除，确保我们向您提供的产品和服务的安全性，以用来保障您的权益不受侵害。同时，当发生账号或系统安全问题时，我们会收集这些信息来优化我们的产品和服务。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">（六）其他</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">如上文所述，如果某一需要收集您的个人信息的功能或产品/服务未能在本《园林工程技术专业教学资源库平台政策》中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们将在收集和使用您的个人信息前，通过更新本《园林工程技术专业教学资源库平台政策》、页面提示、弹窗、消息通知、网站公告或其他便于您获知的方式另行向您说明，并为您提供自主选择同意的方式，且在征得您明示同意后收集和使用。请您知悉，如信息无法单独或结合其他信息识别或关联到您的个人身份的，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时、我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本政策处理与保护。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">四、我们如何使用个人信息</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、我们会在下列情况使用你的个人信息，向你提供使用的各项产品与/或服务，并维护、改进这些服务。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(1)发布功能：在意见反馈应用中，你可以发布文字、图片，我们需要收集你发布的信息，并向后端相关管理部门展示你的姓名、头像等业务相关的个人信息及发布内容。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(2)认证功能：你可以使用手机号进行账号注册，当你实名认证时，我们需要收集你的姓名、有效身份证件信息、人脸信息进行实名认证。信息审核通过后，进行课程学习及相关业务信息查询，在课程学习、课程考试应用中，我们需要收集你的账号、人脸信息，并向后端相关管理部门展示你的账号、人脸照片等业务相关的个人信息。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(3)课程学习、考试及成绩查询功能：在我的、模拟考试、成绩查询、我的课程应用中，你可以进行课程学习、课程考试、成绩查询，我们需要收集你的学习信息、账号信息，并向后端相关管理部门展示你的账号、学习记录、考试成绩等业务相关的信息。</p>


    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、需要提醒你注意，以下情形中，使用你的个人信息无需你的同意：</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(1)与个人信息控制者履行法律法规规定的义务相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(2)与国家安全、国防安全直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(3)与公共安全、公共卫生、重大公共利益直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(4)与刑事侦查、起诉、审判和判决执行等直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(5)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(6)所收集的个人信息是你自行向社会公众公开的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(7)从合法公开披露的信息中收集的你的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(8)根据你的要求签订和履行合同所必需的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">(9)用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">五、我们如何存储和保护个人信息</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。例如：通过网络安全层软件（SSL）进行加密传输、信息加密存储、严格限制数据中心的访问。传输和存储个人敏感信息（含个人生物识别信息）时，我们将采用加密、权限控制等安全措施。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、请您务必妥善保管好您的登录名及其他身份信息。您在使用服务时，我们会通过您的登录名及其他身份信息来识别您的身份。一旦您泄漏了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现登录名及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">3、在您终止使用服务后，我们会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">六、我们如何共享、转让、公开披露个人信息</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">我们充分知晓因违法共享、转让、公开披露信息对个人信息主体造成损害时所应承担的法律责任，对于你的个人信息的一切共享、转让、公开披露，我们将严格按照以下条款进行：</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">(一)共享</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">尊重用户个人隐私是我们的一项基本原则。除以下情形外，我们不会与任何公司、组织和个人分享你的个人信息：</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、在获取明确同意的情况下共享：获得你的明确同意后，我们会与其他方共享你的个人信息；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、我们可能会按照司法机关或行政机关的要求，对外共享你的个人信息。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">3、与我们的关联公司共享：你的个人信息可能会与平台的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求你的授权同意。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享你的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享你的个人信息，并且只会共享提供服务所必要的个人信息，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">当你使用某些功能时，我们可能会接入第三方提供的软件开发包以实现相关功能。目前，我们合作的第三方服务商包括：</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">A.人脸识别服务：为给你体提供人脸识别服务，第三方人脸识别服务商阿里云会收集你的信息。</p>
    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">B.身份证识别服务：为给你提供你身份证识别服务，第三方身份证服务商阿里云会收集你的信息。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">(二)转让</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">我们不会将你的个人信息转让给任何公司、组织和个人，但以下情况除外：</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、在获取明确同意的情况下转让：获得你的明确同意后，我们会向其他方转让你的个人信息。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有你个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向你征求授权同意。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">(三)公开披露</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">我们仅会在以下情况下，公开披露你的个人信息：</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、获得你明确同意后。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、基于法律的披露：在法律、法律程序、诉讼或政府主管部分强制性要求的情况下，我们可能会公开披露你的个人信息。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">(四)共享、转让、公开披露个人信息授权同意的例外情形</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">根据法律法规的规定，在下述情况下，共享、转让、公开披露你的个人信息无需事先征得你的授权同意：</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、与我们履行法律法规规定的义务相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、与国家安全、国防安全直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">3、与公共安全、公共卫生、重大公共利益直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">4、与刑事侦查、起诉、审判和判决执行等直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">5、出于维护你或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">6、你自行向社会公众公开的个人信息；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>


    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">七、您如何访问和管理自己的个人信息</h5>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">在您使用服务期间，为了您可以更加便捷地访问和管理您的信息，您可以参考下面的指引进行操作。</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">1、管理您的信息</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">您可通过登录，在“我的→个人资料”中：查询姓名、性别、手机号码、身份证号、等信息。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">2、如您发现我们收集、使用您个人信息的行为，违反了法律法规规定或违反了与您的约定，您可联系我们要求删除相应的信息。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">3、尽管有上述约定，但按照相关法律法规及国家标准，在以下情形中，我们可能无法响应您的请求：</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">（1）与国家安全、国防安全直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">（3）与犯罪侦查、起诉、审判和执行判决等直接相关的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">（4）有充分证据表明您存在主观恶意或滥用权利的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">（5）响应您的请求将导致其他个人、组织的合法权益受到严重损害的；</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">（6）涉及商业秘密的</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">4、如您对本政策存在任何疑问，或对于您的个人信息处理存在任何投诉、意见，请联系我们</p>


    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">八、本政策的适用及更新</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">所有服务均适用本政策，除非相关服务已有独立的隐私权政策或相应的用户服务协议当中存在特殊约定。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">由于用户较多，如本政策发文更新，我们将以弹窗提示或在官方网站发布公告的方式来通知您。如您在本政策更新生效后继续使用服务，即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。</p>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">您可在通过“我的→关于我们”中查看本政策。我们鼓励您在每次使用时都查阅我们的隐私政策。</p>

    <h5 style="font-size:12px;margin-bottom: 10px;color: #333333;">九、如何联系我们</h5>

    <p style="font-size:12px;margin-bottom: 10px;color: #999999;">您对本隐私政策有任何疑问或您在使用我们提供的服务时个人信息受到了侵扰，您可以联系我们，或通过意见反馈进行反馈。</p>
</div>`
    }
  },

  mounted(){},
  methods: {}
}
</script>
<style lang='scss' scoped>
.privacywarp{
    width: 100%;
.privcenter{
    width: 1200px;
    margin: 0 auto;
}
}

</style>
